/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Downloadlinksarchivetitle3Inputs */

const en_downloadlinksarchivetitle3 = /** @type {(inputs: Downloadlinksarchivetitle3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archive "${i?.name}"?`)
};

const de_downloadlinksarchivetitle3 = /** @type {(inputs: Downloadlinksarchivetitle3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.name}“ archivieren?`)
};

/**
* | output |
* | --- |
* | "Archive \"{name}\"?" |
*
* @param {Downloadlinksarchivetitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksarchivetitle3 = /** @type {((inputs: Downloadlinksarchivetitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksarchivetitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksarchivetitle3(inputs)
	return de_downloadlinksarchivetitle3(inputs)
});
export { downloadlinksarchivetitle3 as "downloadLinksArchiveTitle" }